import { render, staticRenderFns } from "./AdminPrivacyFooter.vue?vue&type=template&id=1eb277e0&scoped=true&"
import script from "./AdminPrivacyFooter.vue?vue&type=script&lang=js&"
export * from "./AdminPrivacyFooter.vue?vue&type=script&lang=js&"
import style0 from "./AdminPrivacyFooter.vue?vue&type=style&index=0&id=1eb277e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb277e0",
  null
  
)

export default component.exports